import t from "./_baseGetTag.js";
import e from "./isObjectLike.js";
var b = t, r = e, i = "[object Symbol]";
function m(o) {
  return typeof o == "symbol" || r(o) && b(o) == i;
}
var y = m;
export {
  y as default
};
//# sourceMappingURL=isSymbol.js.map
